// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dimension-input-container {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
  }
  
  .input-container {
    width: 100%;
  }
  
  .inline-inputs {
    display: flex;
    gap: 10px;
  }
  
  .inline-inputs input {
    width: 50%;
  }
  
  .radio-group {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    background-color: #F6F7F9;
    padding: 10px;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    font-size: 16px;
  }
  
  .radio-group label {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 16px;
    margin-left: 5px;
    margin-right: 5px;
  }

  .dimension-input{
    margin-bottom: 0!important;
    background-color: #F6F7F9;
    outline: none;
    border: none;
    height: 50px!important;
    border-radius: 6px;
    color: #9ba2ad;
    font-size: 16px;
    padding: 0px;
    padding-left: 20px;
    box-sizing: border-box;
    transition: all 0.3s ease;
  }

  .dimension-input:hover{
    background-color: #d3e0fa;
  }

  .dimension-input input{
    color: #666666;
    background-color: transparent;
  }

.dimension-input::placeholder{
    color: #9ba2ad;
}`, "",{"version":3,"sources":["webpack://./src/dimensionsInput.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,6BAA6B;EAC/B;;AAEF;IACI,cAAc;AAClB","sourcesContent":[".dimension-input-container {\n    display: flex;\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .input-container {\n    width: 100%;\n  }\n  \n  .inline-inputs {\n    display: flex;\n    gap: 10px;\n  }\n  \n  .inline-inputs input {\n    width: 50%;\n  }\n  \n  .radio-group {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n    background-color: #F6F7F9;\n    padding: 10px;\n    align-items: center;\n    justify-content: center;\n    border-radius: 6px;\n    font-size: 16px;\n  }\n  \n  .radio-group label {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    font-size: 16px;\n    margin-left: 5px;\n    margin-right: 5px;\n  }\n\n  .dimension-input{\n    margin-bottom: 0!important;\n    background-color: #F6F7F9;\n    outline: none;\n    border: none;\n    height: 50px!important;\n    border-radius: 6px;\n    color: #9ba2ad;\n    font-size: 16px;\n    padding: 0px;\n    padding-left: 20px;\n    box-sizing: border-box;\n    transition: all 0.3s ease;\n  }\n\n  .dimension-input:hover{\n    background-color: #d3e0fa;\n  }\n\n  .dimension-input input{\n    color: #666666;\n    background-color: transparent;\n  }\n\n.dimension-input::placeholder{\n    color: #9ba2ad;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
